import { Dropdown } from 'component/Dropdown/Dropdown'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { PricePopover } from 'page/catalog/price/PricePopover'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { MouseEvent } from 'react'
import css from './PriceFilter.module.scss'

export const PriceFilter = observer(() => {
  const { form } = useDemo()
  const { min_price, max_price } = form

  const add = min_price == null && max_price == null

  const onOpened = useLatestCallback((value: boolean) => {
    form.price_open = value
  })

  const onClear = useLatestCallback((event: MouseEvent) => {
    event.stopPropagation()
    form.min_price = null
    form.max_price = null
    form.refresh()
  })

  const content = <PricePopover />

  return (
    <Dropdown height={32} content={content} width={350} onOpen={onOpened}>
      <span>{i18n('Price')}</span>
      {add ? (
        <Icon size={16} name="add" tertiary />
      ) : (
        <Space gap={4} className={css.countContainer}>
          <span className={css.buttonCount}>
            <Icon size={16} name="add" />
          </span>
          <div className={css.clearButton} onClick={onClear}>
            <Icon size={12} name="close" />
          </div>
        </Space>
      )}
    </Dropdown>
  )
})
